<template>
<div class="header-nav shadow-sm pr-4 pl-4 search-bar">
    <div class="form-group with-input-icon">
        <div class="input-group">
          <div class="input-group-prepend">
              <label class="input-group-text" for="searchBar">
                  <img class="icon-24" :src="$util.asset('goobank_assets/assets/icons/magnify-glass@2x.png')">
              </label>
          </div>
          <input class="form-control" id="searchBar" type="text" :placeholder="placeholder" :value="value" @input="updateInput($event)">
        </div>
    </div>
</div>
</template>

<script>
export default {
  methods: {
    updateInput ($event) {
      this.$emit('input', $event.target.value)
    }
  },
  props: {
    placeholder: {
      type: String,
      default: 'ค้นหา'
    },
    value: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
</style>
